/**
 * 5.56 tiered AOV gift rewards ladder.
 * Keeps the ladder tiers in sync with variant selection and keeps one
 * tagged gift bundle paired with the highest qualifying 5.56 tier in cart.
 */
(function() {
  var OFFER_ID = '556-tiered-gift';
  var ICON_UNLOCKED = '✓';
  var ICON_LOCKED = '🔒';
  var BOOT_RETRY_DELAY = 50;
  var BOOT_RETRY_LIMIT = 40;
  var STATE_SYNC_DELAY = 75;
  var bootState = window.__aov556UpsellBoot || { attempts: 0, timer: null };

  window.__aov556UpsellBoot = bootState;

  function toInt(value) {
    var number = parseInt(value, 10);
    return Number.isFinite(number) ? number : null;
  }

  function scheduleStart() {
    if (bootState.timer || bootState.attempts >= BOOT_RETRY_LIMIT) return;

    bootState.attempts += 1;
    bootState.timer = setTimeout(function() {
      bootState.timer = null;
      start();
    }, BOOT_RETRY_DELAY);
  }

  function start() {
    var roots = [];
    var firstRoot = null;
    var cartFetch = window.__nativeFetch || fetch;
    var syncingGift = false;
    var cleanupCallbacks = [];
    var stateSyncTimer = null;
    var pubSubRetryTimer = null;
    var countdownTimer = null;
    var proofObserver = null;
    var didSubscribeToPubSub = false;
    var didApplyPreferredTier = false;
    var presentation = 'offer';
    var offerProfile = '556';
    var maxTier = '1000';
    var tiers = {
      300: { key: '300', variantId: null, giftVariantId: null, label: '', giftValue: '' },
      500: { key: '500', variantId: null, giftVariantId: null, label: '', giftValue: '' },
      1000: { key: '1000', variantId: null, giftVariantId: null, label: '', giftValue: '' }
    };

    function destroy() {
      if (stateSyncTimer) clearTimeout(stateSyncTimer);
      if (pubSubRetryTimer) clearInterval(pubSubRetryTimer);
      if (countdownTimer) clearInterval(countdownTimer);

      cleanupCallbacks.forEach(function(cleanup) {
        cleanup();
      });

      cleanupCallbacks = [];
      roots = [];
      firstRoot = null;
      proofObserver = null;
    }

    function hasOffer(tier) {
      return Boolean(tier && tier.variantId && tier.giftVariantId);
    }

    function hasTier(tier) {
      return Boolean(tier && tier.variantId);
    }

    function getTierInput(tierKey) {
      return document.querySelector('variant-selects[data-primary] input[type="radio"][data-aov556-tier-option="' + tierKey + '"]');
    }

    function getTierVariantIdFromPicker(tierKey) {
      var input = getTierInput(tierKey);
      return input ? toInt(input.getAttribute('data-aov556-variant-id')) : null;
    }

    function getTierLabelFromPicker(tierKey) {
      var input = getTierInput(tierKey);
      if (!input) return '';

      if (input.id) {
        var selectedLabel = document.querySelector('label[for="' + input.id + '"] .variant-card__name');
        if (selectedLabel && selectedLabel.textContent.trim()) return selectedLabel.textContent.trim();
      }

      return input.value || '';
    }

    function refreshStateFromDom() {
      roots = Array.from(document.querySelectorAll('[data-556-aov-upsell]'));
      firstRoot = roots[0] || null;

      if (firstRoot) {
        presentation = firstRoot.getAttribute('data-aov556-presentation') || 'offer';
        offerProfile = firstRoot.getAttribute('data-aov556-offer-profile') || '556';
        maxTier = firstRoot.getAttribute('data-aov556-max-tier') || '1000';
      } else {
        var bodyClassList = document.body && document.body.classList;
        var is22lrAovV1Template = bodyClassList && (bodyClassList.contains('template-product-22lr-aov-upsell-v1') || bodyClassList.contains('template-product-22lr-aov-upsell-v1-sb'));
        var is22lrAovTemplate = bodyClassList && (
          bodyClassList.contains('template-product-22lr-blazer-aov-pdp-0505') ||
          bodyClassList.contains('template-product-22lr-aov-upsell-pdp') ||
          is22lrAovV1Template
        );
        presentation = is22lrAovTemplate ? 'pdp' : presentation;
        offerProfile = is22lrAovTemplate ? '22lr' : offerProfile;
        maxTier = is22lrAovV1Template ? '500' : '1000';
      }

      tiers[300].variantId = (firstRoot && toInt(firstRoot.getAttribute('data-tier-300-variant-id'))) || getTierVariantIdFromPicker('300');
      tiers[300].giftVariantId = firstRoot ? toInt(firstRoot.getAttribute('data-tier-300-gift-variant-id')) : null;
      tiers[300].label = (firstRoot && firstRoot.getAttribute('data-tier-300-label')) || getTierLabelFromPicker('300') || 'variant 2';
      tiers[300].giftValue = (firstRoot && firstRoot.getAttribute('data-tier-300-gift-value')) || (offerProfile === '22lr' ? '$100' : '$80');
      tiers[500].variantId = (firstRoot && toInt(firstRoot.getAttribute('data-tier-500-variant-id'))) || getTierVariantIdFromPicker('500');
      tiers[500].giftVariantId = firstRoot ? toInt(firstRoot.getAttribute('data-tier-500-gift-variant-id')) : null;
      tiers[500].label = (firstRoot && firstRoot.getAttribute('data-tier-500-label')) || getTierLabelFromPicker('500') || 'variant 3';
      tiers[500].giftValue = (firstRoot && firstRoot.getAttribute('data-tier-500-gift-value')) || (offerProfile === '22lr' ? '$200' : '$160');
      tiers[1000].variantId = (firstRoot && toInt(firstRoot.getAttribute('data-tier-1000-variant-id'))) || getTierVariantIdFromPicker('1000');
      tiers[1000].giftVariantId = firstRoot ? toInt(firstRoot.getAttribute('data-tier-1000-gift-variant-id')) : null;
      tiers[1000].label = (firstRoot && firstRoot.getAttribute('data-tier-1000-label')) || getTierLabelFromPicker('1000') || 'variant 4';
      tiers[1000].giftValue = (firstRoot && firstRoot.getAttribute('data-tier-1000-gift-value')) || (offerProfile === '22lr' ? '$300' : '$465');
      if (maxTier === '500') {
        tiers[1000].variantId = null;
        tiers[1000].giftVariantId = null;
        tiers[1000].label = '';
        tiers[1000].giftValue = '';
      }
      return hasTier(tiers[300]) || hasTier(tiers[500]) || hasTier(tiers[1000]);
    }

    if (!refreshStateFromDom()) {
      scheduleStart();
      return;
    }

    if (bootState.timer) clearTimeout(bootState.timer);
    window.__aov556UpsellBoot = null;

    if (window.__aov556Upsell && typeof window.__aov556Upsell.destroy === 'function') {
      window.__aov556Upsell.destroy();
    }
    window.__aov556Upsell = { destroy: destroy };

    function cleanPayload(payload) {
      var clean = {};
      Object.keys(payload || {}).forEach(function(key) {
        if (payload[key] !== undefined) clean[key] = payload[key];
      });
      return clean;
    }

    function track(eventName, params) {
      var payload = cleanPayload(Object.assign({
        offer_id: OFFER_ID,
        event_category: '556_aov_offer',
        page_location: window.location.href,
        page_path: window.location.pathname,
        page_title: document.title
      }, params || {}));

      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: eventName }, payload));
      } catch (error) {}

      try {
        if (typeof window.gtag === 'function') window.gtag('event', eventName, payload);
      } catch (error) {}

      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish(eventName, payload);
        }
      } catch (error) {}
    }

    function getButtonText(button) {
      return button ? button.textContent.trim().replace(/\s+/g, ' ') : '';
    }

    function getButtonLocation(button) {
      if (!button || !button.closest) return 'pdp';
      if (button.closest('.aov556-offer-hero')) return 'hero';
      if (button.closest('.sticky-atc, .sticky-atc--aov556')) return 'sticky_add_to_cart';
      if (button.closest('[data-aov556-nudge]')) return 'upgrade_nudge';
      if (button.closest('[data-aov556-tier]')) return 'bonus_ladder';
      return 'pdp';
    }

    function getRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function getCartSections() {
      var miniCart = document.querySelector('mini-cart');
      if (miniCart && typeof miniCart.getSectionsToRender === 'function') {
        return miniCart.getSectionsToRender().map(function(section) { return section.id; });
      }
      return ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
    }

    function refreshMiniCart(sectionsPayload) {
      var miniCart = document.querySelector('mini-cart');
      if (!miniCart || typeof miniCart.renderContents !== 'function' || !sectionsPayload) return;
      miniCart.renderContents({ sections: sectionsPayload });
    }

    function getTierByVariantId(variantId) {
      if (hasTier(tiers[1000]) && variantId == tiers[1000].variantId) return '1000';
      if (hasTier(tiers[500]) && variantId == tiers[500].variantId) return '500';
      if (hasTier(tiers[300]) && variantId == tiers[300].variantId) return '300';
      return 'base';
    }

    function getVariantIdFromUrl() {
      try {
        return toInt(new URL(window.location.href).searchParams.get('variant'));
      } catch (error) {
        return null;
      }
    }

    function getPrimarySelectedInput() {
      return document.querySelector('variant-selects[data-primary] input[type="radio"][data-aov556-tier-option]:checked');
    }

    function getSelectedTierFromPrimary() {
      var selectedInput = getPrimarySelectedInput();
      return selectedInput && selectedInput.dataset ? selectedInput.dataset.aov556TierOption : null;
    }

    function getSelectedVariantId() {
      var selectedInput = getPrimarySelectedInput();
      var selectedInputVariantId = selectedInput ? toInt(selectedInput.getAttribute('data-aov556-variant-id')) : null;
      if (selectedInputVariantId) return selectedInputVariantId;

      var urlVariantId = getVariantIdFromUrl();
      if (urlVariantId && getTierByVariantId(urlVariantId) !== 'base') return urlVariantId;

      var enabledInput = document.querySelector('product-form[data-aov556-offer] form[data-type="add-to-cart-form"] input[name="id"]:not([disabled])');
      if (enabledInput) return toInt(enabledInput.value);

      var input = document.querySelector('input.product-variant-id[name="id"]');
      return input ? toInt(input.value) : null;
    }

    function getVariantIdForTier(tierKey) {
      if (tierKey === '1000' && hasTier(tiers[1000])) return tiers[1000].variantId;
      if (tierKey === '500' && hasTier(tiers[500])) return tiers[500].variantId;
      if (tierKey === '300' && hasTier(tiers[300])) return tiers[300].variantId;
      if (tierKey === 'base') {
        var singleQuantity = document.querySelector('[data-aov556-single-quantity]');
        var singleVariantId = singleQuantity && toInt(singleQuantity.getAttribute('data-aov556-single-variant-id'));
        if (singleVariantId) return singleVariantId;
      }
      return getSelectedVariantId();
    }

    function syncSingleQuantity(selectedVariantId) {
      document.querySelectorAll('[data-aov556-single-quantity]').forEach(function(wrapper) {
        var singleVariantId = toInt(wrapper.getAttribute('data-aov556-single-variant-id'));
        var isSingleVariant = Boolean(singleVariantId && selectedVariantId == singleVariantId);
        var input = wrapper.querySelector('input.quantity__input');

        wrapper.hidden = !isSingleVariant;
        wrapper.setAttribute('aria-hidden', isSingleVariant ? 'false' : 'true');

        wrapper.querySelectorAll('button').forEach(function(button) {
          if (isSingleVariant) {
            button.removeAttribute('disabled');
          } else {
            button.setAttribute('disabled', 'disabled');
          }
        });

        if (!input) return;

        if (isSingleVariant) {
          input.removeAttribute('disabled');
          return;
        }

        input.value = input.getAttribute('data-min') || input.min || '1';
        input.setAttribute('disabled', 'disabled');
      });
    }

    function setLadderTierState(tierEl, unlocked) {
      tierEl.classList.toggle('aov556__ladder-tier--locked', !unlocked);
      tierEl.classList.toggle('aov556__ladder-tier--unlocked', unlocked);

      var icon = tierEl.querySelector('[data-aov556-icon]');
      if (icon) icon.textContent = unlocked ? ICON_UNLOCKED : ICON_LOCKED;
    }

    function getNudgeCopy(tierKey) {
      if (presentation === 'pdp') {
        if (offerProfile === '22lr') {
          if (tierKey === 'base' && hasTier(tiers[300])) {
            if (hasTier(tiers[1000])) {
              return 'Choose the range pack, or jump to Stock-Up for the largest included range kit.';
            }
            if (hasTier(tiers[500])) {
              return 'Choose 4 boxes for the included range kit, or 6 boxes to double the kit.';
            }
            return 'Choose 4 boxes for the included 200 rds Winchester 9mm + 20-target range kit.';
          }
          if (tierKey === '300' && hasTier(tiers[500])) {
            return hasTier(tiers[1000])
              ? 'Range Day doubles the included range kit.'
              : '6 boxes doubles the included range kit to 400 rds Winchester 9mm + 40 targets.';
          }
          if (tierKey === '500' && hasTier(tiers[1000])) {
            return 'Range Day is solid. Stock-Up adds the largest included range kit: 600 rounds of 9mm and 60 targets.';
          }
          if (tierKey === '1000' && hasTier(tiers[1000])) {
            return 'Stock-Up selected: the largest range kit is included.';
          }
          if (tierKey === '500' && !hasTier(tiers[1000])) {
            return '6-box range pack selected: 400 rds Winchester 9mm + 40 targets included.';
          }
        }
        if (tierKey === 'base' && hasTier(tiers[300])) {
          return '300 rounds includes 200 rounds of Winchester 9mm and 20 splatter targets.';
        }
        if (tierKey === '300' && hasTier(tiers[500])) {
          return '500 rounds increases the included bonus to 400 rounds of 9mm and 40 targets.';
        }
        if (tierKey === '500' && hasTier(tiers[1000])) {
          return '1,000 rounds adds 800 rounds of 9mm, 80 targets, and the custom ammo can.';
        }
        if (tierKey === '1000' && hasTier(tiers[1000])) {
          return 'All package bonuses are included with this option.';
        }
      }

      if (tierKey === 'base' && hasTier(tiers[300])) {
        return 'Start with 300 rounds to unlock free 9mm + targets.';
      }
      if (tierKey === '300' && hasTier(tiers[500])) {
        return 'Upgrade to 500 rounds for 400 free 9mm rounds + 40 targets.';
      }
      if (tierKey === '500' && hasTier(tiers[1000])) {
        return 'Upgrade to 1,000 rounds for 800 free 9mm rounds, 80 targets, and a free custom laser engraved ammo can.';
      }
      return '';
    }

    function getNudgeAction(tierKey) {
      if (presentation === 'pdp' && offerProfile === '22lr') {
        if (tierKey === 'base' && hasTier(tiers[300])) return { tier: '300', label: hasTier(tiers[1000]) ? 'Select Casual Plinking' : 'Select 4-Box' };
        if (tierKey === '300' && hasTier(tiers[500])) return { tier: '500', label: hasTier(tiers[1000]) ? 'Select Range Day' : 'Select 6-Box' };
        if (tierKey === '500' && hasTier(tiers[1000])) return { tier: '1000', label: 'Select Stock-Up' };
        return null;
      }
      if (tierKey === 'base' && hasTier(tiers[300])) return { tier: '300', label: 'Select 300' };
      if (tierKey === '300' && hasTier(tiers[500])) return { tier: '500', label: presentation === 'pdp' ? 'Select 500' : 'Upgrade to 500' };
      if (tierKey === '500' && hasTier(tiers[1000])) return { tier: '1000', label: presentation === 'pdp' ? 'Select 1,000' : 'Upgrade to 1,000' };
      return null;
    }

    function getSubmitCopy(tierKey) {
      if (offerProfile === '22lr') {
        if (tierKey === '1000' && hasTier(tiers[1000])) {
          return 'Add 8-Box Package';
        }
        if (tierKey === '500' && hasTier(tiers[500])) {
          return maxTier === '500' ? 'Add 6-Box Range Pack' : 'Add 6-Box Package';
        }
        if (tierKey === '300' && hasTier(tiers[300])) {
          return maxTier === '500' ? 'Add 4-Box Range Pack' : 'Add 4-Box Package';
        }
        return maxTier === '500' ? 'Add Range Pack' : 'Add Package';
      }
      if (tierKey === '1000' && hasTier(tiers[1000])) {
        return 'Add 1,000-Round Bundle';
      }
      if (tierKey === '500' && hasTier(tiers[500])) {
        return 'Add 500-Round Bundle';
      }
      if (tierKey === '300' && hasTier(tiers[300])) {
        return 'Add 300-Round Bundle';
      }
      return 'Add to Cart';
    }

    function getStickyBonusCopy(tierKey) {
      if (offerProfile === '22lr') {
        if (tierKey === '1000' && hasTier(tiers[1000])) {
          return '600 rds 9mm + 60 targets';
        }
        if (tierKey === '500' && hasTier(tiers[500])) {
          return '400 rds 9mm + 40 targets';
        }
        if (tierKey === '300' && hasTier(tiers[300])) {
          return '200 rds 9mm + 20 targets';
        }
        if (hasTier(tiers[1000])) {
          return 'Up to 600 rds 9mm + targets';
        }
        if (hasTier(tiers[500])) {
          return 'Up to 400 rds 9mm + targets';
        }
        if (hasTier(tiers[300])) {
          return 'Up to 200 rds 9mm + targets';
        }
        return '';
      }
      if (tierKey === '1000' && hasTier(tiers[1000])) {
        return '800 rds 9mm + 80 targets + custom laser engraved ammo can free';
      }
      if (tierKey === '500' && hasTier(tiers[500])) {
        return '400 rds 9mm free + 40 targets';
      }
      if (tierKey === '300' && hasTier(tiers[300])) {
        return '200 rds 9mm free + 20 targets';
      }
      if (hasTier(tiers[1000])) {
        return 'Up to 800 rds 9mm + targets + custom laser engraved ammo can free';
      }
      if (hasTier(tiers[500])) {
        return 'Up to 400 rds 9mm free + targets';
      }
      if (hasTier(tiers[300])) {
        return 'Up to 200 rds 9mm free + targets';
      }
      return '';
    }

    function getPackageLabel(tierKey) {
      if (offerProfile === '22lr') {
        if (tierKey === '1000' && hasTier(tiers[1000])) return '8-Box Stock-Up Pack';
        if (tierKey === '500' && hasTier(tiers[500])) return '6-Box Range Pack';
        if (tierKey === '300' && hasTier(tiers[300])) return '4-Box Range Pack';
      }
      if (tierKey === '1000' && hasTier(tiers[1000])) return '1,000-Round Bundle';
      if (tierKey === '500' && hasTier(tiers[500])) return '500-Round Bundle';
      if (tierKey === '300' && hasTier(tiers[300])) return '300-Round Bundle';

      var selectedInput = document.querySelector('variant-selects[data-primary] input[type="radio"][data-aov556-tier-option="base"]:checked');
      if (selectedInput && selectedInput.id) {
        var selectedLabel = document.querySelector('label[for="' + selectedInput.id + '"] .variant-card__name');
        if (selectedLabel && selectedLabel.textContent.trim()) return selectedLabel.textContent.trim();
      }

      var selectedStickyOption = document.querySelector('.sticky-atc--aov556 variant-selects[data-sticky] select option:checked');
      if (selectedStickyOption && selectedStickyOption.textContent.trim()) return selectedStickyOption.textContent.trim();

      return 'Selected Package';
    }

    function getGiftVariantIdForTier(tierKey) {
      if (tierKey === '1000' && hasOffer(tiers[1000])) return tiers[1000].giftVariantId;
      if (tierKey === '500' && hasOffer(tiers[500])) return tiers[500].giftVariantId;
      if (tierKey === '300' && hasOffer(tiers[300])) return tiers[300].giftVariantId;
      return null;
    }

    function getOfferMeasurementPayload(tierKey, params) {
      tierKey = tierKey || getTierByVariantId(getSelectedVariantId());

      return cleanPayload(Object.assign({
        offer_profile: offerProfile,
        presentation: presentation,
        max_tier: maxTier,
        selected_tier: tierKey,
        selected_variant_id: getVariantIdForTier(tierKey),
        selected_package: getPackageLabel(tierKey),
        selected_bonus: getStickyBonusCopy(tierKey),
        selected_price_cents: getTierPrice(tierKey),
        selected_gift_variant_id: getGiftVariantIdForTier(tierKey),
        is_revenue_safe_tier: isTierRevenueSafe(tierKey)
      }, params || {}));
    }

    function getProofState(tierKey) {
      if (offerProfile !== '22lr') return null;

      if (tierKey === '1000' && hasTier(tiers[1000])) {
        return {
          packageLabel: '8-box stock-up pack',
          roundCount: '4,200 .22 LR rounds',
          bonusCopy: 'Included: 600 rds Winchester 9mm + 60 splatter targets',
          cartBonusCopy: '600 rds Winchester 9mm + 60 targets',
          cartSummaryCopy: '600 rds 9mm + 60 targets',
          mediaKitPackageLabel: '8-box stock-up pack',
          mediaKitBoxCount: '8x',
          mediaKitRoundCount: '4,200 .22 LR',
          mediaKitWinchesterCount: '600 rds',
          winchesterCount: '600 rounds',
          mediaKitTargetCount: '60 targets',
          targetCount: '60 targets'
        };
      }

      if (tierKey === '500' && hasTier(tiers[500])) {
        return {
          packageLabel: '6-box range pack',
          roundCount: '3,150 .22 LR rounds',
          bonusCopy: 'Included: 400 rds Winchester 9mm + 40 splatter targets',
          cartBonusCopy: '400 rds Winchester 9mm + 40 targets',
          cartSummaryCopy: 'full range kit',
          mediaKitPackageLabel: '6-box range pack',
          mediaKitBoxCount: '6x',
          mediaKitRoundCount: '3,150 .22 LR',
          mediaKitWinchesterCount: '400 rds',
          winchesterCount: '400 rounds',
          mediaKitTargetCount: '40 targets',
          targetCount: '40 targets'
        };
      }

      if (tierKey === '300' && hasTier(tiers[300])) {
        return {
          packageLabel: '4-box range pack',
          roundCount: '2,100 .22 LR rounds',
          bonusCopy: 'Included: 200 rds Winchester 9mm + 20 splatter targets',
          cartBonusCopy: '200 rds Winchester 9mm + 20 targets',
          cartSummaryCopy: '200 rds 9mm + 20 targets',
          mediaKitPackageLabel: '4-box range pack',
          mediaKitBoxCount: '4x',
          mediaKitRoundCount: '2,100 .22 LR',
          mediaKitWinchesterCount: '200 rds',
          winchesterCount: '200 rounds',
          mediaKitTargetCount: '20 targets',
          targetCount: '20 targets'
        };
      }

      if (maxTier === '500' && hasTier(tiers[500])) return getProofState('500');
      if (hasTier(tiers[300])) return getProofState('300');

      return null;
    }

    function setProofText(module, selector, value) {
      var el = module.querySelector(selector);
      if (el && value) el.textContent = value;
    }

    function syncProofModuleState(tierKey) {
      var proofState = getProofState(tierKey);
      if (!proofState) return;

      document.querySelectorAll('[data-aov556-proof-module]').forEach(function(module) {
        module.setAttribute('data-aov556-proof-package', proofState.packageLabel);
        module.setAttribute('data-aov556-proof-bonus', proofState.bonusCopy);

        setProofText(module, '[data-aov556-proof-package-label]', proofState.packageLabel);
        setProofText(module, '[data-aov556-proof-round-count]', proofState.roundCount);
        setProofText(module, '[data-aov556-proof-winchester-count]', proofState.winchesterCount);
        setProofText(module, '[data-aov556-proof-target-count]', proofState.targetCount);
        setProofText(module, '[data-aov556-proof-bonus-heading]', 'Range kit matched to this pack');
        setProofText(module, '[data-aov556-proof-bonus-copy]', proofState.bonusCopy + '.');
      });

      document.querySelectorAll('[data-aov556-cart-preview]').forEach(function(module) {
        setProofText(module, '[data-aov556-cart-preview-package]', proofState.packageLabel);
        setProofText(module, '[data-aov556-cart-preview-bonus]', proofState.cartSummaryCopy || proofState.cartBonusCopy || proofState.bonusCopy);
      });

      document.querySelectorAll('[data-aov556-media-offer]').forEach(function(module) {
        setProofText(module, '[data-aov556-media-package-label]', proofState.packageLabel);
        setProofText(module, '[data-aov556-media-round-count]', proofState.roundCount);
        setProofText(module, '[data-aov556-media-bonus]', proofState.cartBonusCopy || proofState.bonusCopy);
      });

      document.querySelectorAll('[data-aov556-media-hero]').forEach(function(module) {
        setProofText(module, '[data-aov556-media-hero-box-count]', proofState.mediaKitBoxCount);
        setProofText(module, '[data-aov556-media-hero-package]', proofState.packageLabel);
        setProofText(module, '[data-aov556-media-hero-rounds]', proofState.roundCount);
        setProofText(module, '[data-aov556-media-hero-bonus]', proofState.cartBonusCopy || proofState.bonusCopy);
      });

      document.querySelectorAll('[data-aov556-media-kit]').forEach(function(module) {
        setProofText(module, '[data-aov556-media-kit-package-label]', proofState.mediaKitPackageLabel || proofState.packageLabel);
        setProofText(module, '[data-aov556-media-kit-box-count]', proofState.mediaKitBoxCount);
        setProofText(module, '[data-aov556-media-kit-round-count]', proofState.mediaKitRoundCount || proofState.roundCount);
        setProofText(module, '[data-aov556-media-kit-winchester-count]', proofState.mediaKitWinchesterCount || proofState.winchesterCount);
        setProofText(module, '[data-aov556-media-kit-target-count]', proofState.mediaKitTargetCount || proofState.targetCount);
      });
    }

    function setConversionCopy(tierKey) {
      var submitCopy = getSubmitCopy(tierKey);
      var selectedTierIsSelectable = tierKey !== 'base' && isTierSelectable(tierKey);
      var productInfo = (firstRoot && firstRoot.closest && firstRoot.closest('product-info')) || document.querySelector('product-info');
      var buttons = [];

      if (productInfo) {
        buttons = buttons.concat(Array.from(productInfo.querySelectorAll('button.product-form__submit[name="add"]')));
      }

      buttons = buttons.concat(Array.from(document.querySelectorAll('.sticky-atc button.product-form__submit[name="add"], .sticky-atc__button[data-sticky-add]')));

      Array.from(new Set(buttons)).forEach(function(button) {
        if (selectedTierIsSelectable) {
          button.disabled = false;
          button.removeAttribute('disabled');
          button.removeAttribute('aria-disabled');
          button.classList.remove('loading');
        } else if (button.disabled || button.getAttribute('aria-disabled') === 'true') {
          return;
        }

        var label = button.querySelector('span');
        if (label) label.textContent = submitCopy;
      });

      document.querySelectorAll('[data-aov556-sticky-bonus]').forEach(function(el) {
        el.textContent = getStickyBonusCopy(tierKey);
      });

      document.querySelectorAll('.sticky-atc--aov556 [data-sticky-title]').forEach(function(el) {
        el.textContent = getPackageLabel(tierKey);
      });
    }

    function syncVariantCardSelection(tierKey) {
      document.querySelectorAll('variant-selects[data-primary] input[type="radio"][data-aov556-tier-option]').forEach(function(input) {
        var shouldBeChecked = input.dataset.aov556TierOption === tierKey;

        if (input.checked !== shouldBeChecked) {
          input.checked = shouldBeChecked;
        }

        Array.from(input.labels || []).forEach(function(label) {
          label.classList.toggle('is-aov556-selected', shouldBeChecked);
        });
      });
    }

    function updateVariantInputs(variantId) {
      if (!variantId) return;

      var scope = firstRoot && firstRoot.closest && firstRoot.closest('product-info');
      if (!scope) scope = document.querySelector('product-info');
      var inputs = [];

      if (scope) {
        inputs = inputs.concat(Array.from(scope.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]')));
      }

      inputs = inputs.concat(Array.from(document.querySelectorAll('product-form[data-aov556-offer] form[data-type="add-to-cart-form"] input[name="id"]')));

      Array.from(new Set(inputs)).forEach(function(input) {
        input.disabled = false;
        input.removeAttribute('disabled');
        if (toInt(input.value) === variantId) return;

        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    function syncStickySelector(tierKey) {
      document.querySelectorAll('.sticky-atc--aov556 variant-selects[data-sticky] select').forEach(function(select) {
        var targetOption = Array.from(select.options).find(function(option) {
          return option.dataset.aov556TierOption === tierKey;
        });

        if (!targetOption) return;

        targetOption.disabled = false;
        targetOption.removeAttribute('disabled');
        targetOption.removeAttribute('data-crossout');
        select.value = targetOption.value;
        Array.from(select.options).forEach(function(option) {
          option.toggleAttribute('selected', option === targetOption);
        });
      });
    }

    function selectTier(tierKey, options) {
      options = options || {};
      if (!refreshStateFromDom()) return;

      var input = document.querySelector('variant-selects[data-primary] input[type="radio"][data-aov556-tier-option="' + tierKey + '"]');
      var variantId = getVariantIdForTier(tierKey);

      if (input) {
        if (input.disabled || input.hasAttribute('data-crossout')) return;

        input.disabled = false;
        input.classList.remove('disabled');
        input.removeAttribute('disabled');
        input.removeAttribute('data-crossout');
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));

        if (options.scroll) {
          var label = input.labels && input.labels[0];
          (label || input).scrollIntoView({ behavior: 'smooth', block: 'center' });
          input.focus({ preventScroll: true });
        }
      } else if (options.scroll && firstRoot) {
        firstRoot.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      updateVariantInputs(variantId);
      syncStickySelector(tierKey);
      setActiveState(tierKey);
    }

    function setActiveState(tierKey) {
      if (!refreshStateFromDom()) return;

      tierKey = tierKey || 'base';
      var is300Unlocked = tierKey === '300' || tierKey === '500' || tierKey === '1000';
      var is500Unlocked = tierKey === '500' || tierKey === '1000';
      var is1000Unlocked = tierKey === '1000';
      var nudgeCopy = getNudgeCopy(tierKey);

      roots.forEach(function(root) {
        root.dataset.currentTier = tierKey;

        var tier300El = root.querySelector('[data-aov556-tier="300"]');
        var tier500El = root.querySelector('[data-aov556-tier="500"]');
        var tier1000El = root.querySelector('[data-aov556-tier="1000"]');

        if (tier300El) setLadderTierState(tier300El, is300Unlocked);
        if (tier500El) setLadderTierState(tier500El, is500Unlocked);
        if (tier1000El) setLadderTierState(tier1000El, is1000Unlocked);

        var nudge = root.querySelector('[data-aov556-nudge]');
        if (nudge) {
          var nudgeText = nudge.querySelector('[data-aov556-nudge-text]');
          var nudgeIcon = nudge.querySelector('.aov556__upgrade-nudge-icon');
          var nudgeButton = nudge.querySelector('[data-aov556-nudge-button]');
          var nudgeAction = getNudgeAction(tierKey);
          if (nudgeCopy) {
            nudge.removeAttribute('hidden');
            if (nudgeText) nudgeText.textContent = nudgeCopy;
            if (nudgeIcon) nudgeIcon.textContent = tierKey === '1000' ? ICON_UNLOCKED : '+';
            if (nudgeButton && nudgeAction) {
              nudgeButton.hidden = false;
              nudgeButton.dataset.aov556UpgradeTier = nudgeAction.tier;
              nudgeButton.textContent = nudgeAction.label;
            } else if (nudgeButton) {
              nudgeButton.hidden = true;
              delete nudgeButton.dataset.aov556UpgradeTier;
            }
          } else {
            nudge.setAttribute('hidden', '');
            if (nudgeButton) nudgeButton.hidden = true;
          }
        }
      });

      setConversionCopy(tierKey);
      syncProofModuleState(tierKey);
      syncVariantCardSelection(tierKey);
      syncStickySelector(tierKey);
      syncSingleQuantity(getVariantIdForTier(tierKey));
      syncAmmoCanState(tierKey);
      syncTargetsState(tierKey);
      syncWinchesterState(tierKey);
    }

    function syncAmmoCanState(tierKey) {
      document.querySelectorAll('[data-aov556-ammo-can]').forEach(function(card) {
        var unlocked = tierKey === '1000';
        card.classList.toggle('is-locked', !unlocked);
        card.classList.toggle('is-unlocked', unlocked);
        card.setAttribute('aria-disabled', unlocked ? 'false' : 'true');
      });
    }

    function syncTargetsState(tierKey) {
      var targetCounts = offerProfile === '22lr' ? { 300: '20', 500: '40', 1000: '60' } : { 300: '20', 500: '40', 1000: '80' };
      var unlocked = tierKey === '300' || tierKey === '500' || tierKey === '1000';

      document.querySelectorAll('[data-aov556-targets]').forEach(function(card) {
        card.classList.toggle('is-locked', !unlocked);
        card.classList.toggle('is-unlocked', unlocked);
        card.setAttribute('aria-disabled', unlocked ? 'false' : 'true');
        card.querySelectorAll('[data-aov556-target-count]').forEach(function(count) {
          count.textContent = targetCounts[tierKey] || '20';
        });
      });
    }

    function syncWinchesterState(tierKey) {
      var winchesterCounts = offerProfile === '22lr' ? { 300: '200', 500: '400', 1000: '600' } : { 300: '200', 500: '400', 1000: '800' };

      document.querySelectorAll('[data-aov556-winchester]').forEach(function(card) {
        card.querySelectorAll('[data-aov556-winchester-count]').forEach(function(count) {
          count.textContent = winchesterCounts[tierKey] || '200';
        });
      });
    }

    function isTierSelectable(tierKey) {
      var input = getTierInput(tierKey);
      return Boolean(input && !input.disabled && !input.hasAttribute('data-crossout') && isTierRevenueSafe(tierKey));
    }

    function getTierPrice(tierKey) {
      var input = getTierInput(tierKey);
      return input ? toInt(input.getAttribute('data-aov556-price-cents')) : null;
    }

    function isTierRevenueSafe(tierKey) {
      if (tierKey !== '500' || presentation !== 'pdp' || offerProfile !== '22lr' || maxTier !== '500') return true;

      var tier500Price = getTierPrice('500');
      var tier300Price = getTierPrice('300');
      if (!tier500Price || !tier300Price) return true;

      return tier500Price > tier300Price;
    }

    function getPreferredDefaultTier() {
      if (presentation !== 'pdp' || offerProfile !== '22lr' || maxTier !== '500') return null;
      if (hasTier(tiers[500]) && isTierSelectable('500')) return '500';
      if (hasTier(tiers[300]) && isTierSelectable('300')) return '300';
      return null;
    }

    function isOfferGiftLine(item) {
      var properties = item.properties || {};
      var isKnownGiftVariant = item.variant_id == tiers[300].giftVariantId ||
        item.variant_id == tiers[500].giftVariantId ||
        item.variant_id == tiers[1000].giftVariantId;

      if (maxTier === '500') return properties._aov_offer === OFFER_ID;
      return isKnownGiftVariant && properties._aov_offer === OFFER_ID;
    }

    function isMatchingGiftLine(item, tier) {
      var properties = item.properties || {};
      return item.variant_id == tier.giftVariantId &&
        properties._aov_offer === OFFER_ID &&
        properties._aov_gift_tier === tier.key;
    }

    function getCartTargetTier(cart) {
      // Higher-tier gift SKUs replace lower-tier gift SKUs; gifts are not additive.
      var has1000Trigger = hasOffer(tiers[1000]) && cart.items.some(function(item) { return item.variant_id == tiers[1000].variantId; });
      if (has1000Trigger) return tiers[1000];

      var has500Trigger = hasOffer(tiers[500]) && cart.items.some(function(item) { return item.variant_id == tiers[500].variantId; });
      if (has500Trigger) return tiers[500];

      var has300Trigger = hasOffer(tiers[300]) && cart.items.some(function(item) { return item.variant_id == tiers[300].variantId; });
      if (has300Trigger) return tiers[300];

      return null;
    }

    async function changeGiftLine(line, quantity) {
      var response = await cartFetch(getRoot() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: line.key,
          quantity: quantity,
          sections: getCartSections(),
          sections_url: window.location.pathname
        })
      });
      var payload = await response.json().catch(function() { return {}; });
      if (response.ok) refreshMiniCart(payload.sections);
    }

    async function removeGiftLines(lines) {
      for (var i = 0; i < lines.length; i++) {
        await changeGiftLine(lines[i], 0);
      }
    }

    async function addGiftToCart(tier) {
      var response = await cartFetch(getRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{
            id: tier.giftVariantId,
            quantity: 1,
            properties: {
              _free_gift: 'true',
              _aov_offer: OFFER_ID,
              _aov_gift_tier: tier.key,
              _aov_parent_variant_id: String(tier.variantId)
            }
          }],
          sections: getCartSections(),
          sections_url: window.location.pathname
        })
      });
      var payload = await response.json().catch(function() { return {}; });

      if (response.ok) {
        refreshMiniCart(payload.sections);
        track('aov556_gift_added', getOfferMeasurementPayload(tier.key, {
          target_tier: tier.key,
          gift_variant_id: tier.giftVariantId,
          trigger_variant_id: tier.variantId
        }));
      } else {
        track('aov556_gift_add_failed', getOfferMeasurementPayload(tier.key, {
          target_tier: tier.key,
          gift_variant_id: tier.giftVariantId,
          trigger_variant_id: tier.variantId,
          response_status: response.status
        }));
      }
    }

    async function syncGiftWithCart() {
      if (!refreshStateFromDom() || syncingGift) return;
      syncingGift = true;

      try {
        var cartResp = await cartFetch(getRoot() + 'cart.js');
        if (!cartResp.ok) {
          track('aov556_gift_sync_failed', getOfferMeasurementPayload(getTierByVariantId(getSelectedVariantId()), {
            failure_stage: 'cart_fetch',
            response_status: cartResp.status
          }));
          return;
        }

        var cart = await cartResp.json();
        var targetTier = getCartTargetTier(cart);
        var giftLines = cart.items.filter(isOfferGiftLine);
        var matchingGiftLines = targetTier ? giftLines.filter(function(line) { return isMatchingGiftLine(line, targetTier); }) : [];
        var staleGiftLines = giftLines.filter(function(line) { return !targetTier || !isMatchingGiftLine(line, targetTier); });

        if (staleGiftLines.length) {
          await removeGiftLines(staleGiftLines);
        }

        if (!targetTier) return;

        if (!matchingGiftLines.length) {
          await addGiftToCart(targetTier);
          return;
        }

        if (matchingGiftLines[0].quantity !== 1) {
          await changeGiftLine(matchingGiftLines[0], 1);
        }

        if (matchingGiftLines.length > 1) {
          await removeGiftLines(matchingGiftLines.slice(1));
        }
      } catch (error) {
        track('aov556_gift_sync_failed', getOfferMeasurementPayload(getTierByVariantId(getSelectedVariantId()), {
          failure_stage: 'exception',
          error_name: error && error.name,
          error_message: error && error.message
        }));
      } finally {
        syncingGift = false;
      }
    }

    function syncLadderFromSelectedVariant() {
      if (!refreshStateFromDom()) return;
      var urlTier = getTierByVariantId(getVariantIdFromUrl());
      var tierKey = urlTier !== 'base' ? urlTier : getSelectedTierFromPrimary() || getTierByVariantId(getSelectedVariantId());
      var preferredTier = getPreferredDefaultTier();
      if (!didApplyPreferredTier && preferredTier && tierKey !== preferredTier && (tierKey === 'base' || tierKey === '300')) {
        didApplyPreferredTier = true;
        selectTier(preferredTier);
        return;
      }
      if (maxTier === '500' && tierKey === 'base') {
        tierKey = preferredTier || (hasTier(tiers[300]) ? '300' : hasTier(tiers[500]) ? '500' : 'base');
        if (tierKey !== 'base') {
          selectTier(tierKey);
          return;
        }
      }
      setActiveState(tierKey);
    }

    function padTimerUnit(value) {
      return value < 10 ? '0' + value : String(value);
    }

    function setCountdownText(root, days, hours, minutes, seconds) {
      var daysEl = root.querySelector('[data-aov556-countdown-days]');
      var hoursEl = root.querySelector('[data-aov556-countdown-hours]');
      var minutesEl = root.querySelector('[data-aov556-countdown-minutes]');
      var secondsEl = root.querySelector('[data-aov556-countdown-seconds]');
      var countdown = root.querySelector('[data-aov556-countdown]');

      if (daysEl) daysEl.textContent = String(days);
      if (hoursEl) hoursEl.textContent = padTimerUnit(hours);
      if (minutesEl) minutesEl.textContent = padTimerUnit(minutes);
      if (secondsEl) secondsEl.textContent = padTimerUnit(seconds);

      if (countdown) {
        countdown.setAttribute(
          'aria-label',
          'Bonus offer ends in ' + days + ' days, ' + hours + ' hours, ' + minutes + ' minutes, and ' + seconds + ' seconds'
        );
      }
    }

    function expireCountdown(root) {
      root.classList.add('is-expired');
      setCountdownText(root, 0, 0, 0, 0);

      var label = root.querySelector('[data-aov556-countdown-label]');
      var title = root.querySelector('[data-aov556-countdown-title]');
      var countdown = root.querySelector('[data-aov556-countdown]');

      if (label) label.textContent = 'Bonus offer ended';
      if (title) title.textContent = offerProfile === '22lr'
        ? 'This .22 LR bonus promotion ended at midnight Eastern.'
        : 'This bonus promotion ended at midnight Eastern.';
      if (countdown) countdown.setAttribute('aria-label', 'Bonus offer ended');
    }

    function updateCountdowns() {
      roots.forEach(function(root) {
        var deadline = new Date(root.getAttribute('data-offer-deadline-at') || '');
        var countdown = root.querySelector('[data-aov556-countdown]');

        if (!countdown || Number.isNaN(deadline.getTime())) return;

        root.classList.add('is-countdown-ready');

        var remaining = deadline.getTime() - Date.now();
        if (remaining <= 0) {
          expireCountdown(root);
          return;
        }

        root.classList.remove('is-expired');

        var days = Math.floor(remaining / 86400000);
        var hours = Math.floor((remaining % 86400000) / 3600000);
        var minutes = Math.floor((remaining % 3600000) / 60000);
        var seconds = Math.floor((remaining % 60000) / 1000);

        setCountdownText(root, days, hours, minutes, seconds);
      });
    }

    function setupCountdowns() {
      updateCountdowns();

      if (countdownTimer) return;
      countdownTimer = setInterval(updateCountdowns, 1000);
    }

    function scheduleLadderSync(delay) {
      if (stateSyncTimer) clearTimeout(stateSyncTimer);
      stateSyncTimer = setTimeout(function() {
        stateSyncTimer = null;
        syncLadderFromSelectedVariant();
      }, delay || 0);
    }

    function getPubSubEvents() {
      if (typeof PUB_SUB_EVENTS === 'undefined') return null;
      return PUB_SUB_EVENTS;
    }

    function addDocumentListener(eventName, handler) {
      document.addEventListener(eventName, handler);
      cleanupCallbacks.push(function() {
        document.removeEventListener(eventName, handler);
      });
    }

    function addSubscription(eventName, handler) {
      if (!eventName || typeof subscribe !== 'function') return;

      var unsubscribe = subscribe(eventName, handler);
      if (typeof unsubscribe === 'function') cleanupCallbacks.push(unsubscribe);
    }

    function setupPubSubSubscriptions() {
      var events = getPubSubEvents();
      if (!events || didSubscribeToPubSub || typeof subscribe !== 'function') return false;

      didSubscribeToPubSub = true;
      addSubscription(events.cartUpdate, syncGiftWithCart);
      addSubscription(events.variantChange, function(event) {
        var selectedId = event && event.data && event.data.variant && event.data.variant.id;
        var tierKey = getTierByVariantId(selectedId);
        updateVariantInputs(toInt(selectedId));
        setActiveState(tierKey);
      });

      return true;
    }

    function getTierOptionFromTarget(target) {
      if (!target) return null;

      if (target.dataset && target.dataset.aov556TierOption !== undefined) {
        return target.dataset.aov556TierOption;
      }

      if (target.tagName === 'SELECT' && target.selectedOptions && target.selectedOptions[0]) {
        return target.selectedOptions[0].dataset.aov556TierOption;
      }

      return null;
    }

    function onDocumentChange(event) {
      var target = event.target;
      var tierOption = getTierOptionFromTarget(target);

      if (tierOption !== null && tierOption !== undefined) {
        var isStickySelector = target.closest && target.closest('variant-selects[data-sticky]');
        var selectionSource = isStickySelector ? 'sticky_selector' : 'primary_picker';

        if (event.isTrusted) {
          track('aov556_tier_selected', getOfferMeasurementPayload(tierOption, {
            selection_source: selectionSource
          }));
        }

        if (isStickySelector) {
          selectTier(tierOption);
          return;
        }

        updateVariantInputs(getVariantIdForTier(tierOption));
        setActiveState(tierOption);
        return;
      }

      if (target && target.matches && target.matches('input.product-variant-id[name="id"]')) {
        setActiveState(getTierByVariantId(toInt(target.value)));
      }
    }

    function mutationHasAovNode(mutation) {
      return Array.from(mutation.addedNodes).some(function(node) {
        if (node.nodeType !== 1) return false;
        if (node.matches && (node.matches('[data-556-aov-upsell]') || node.matches('[data-aov556-proof-module]') || node.matches('product-info'))) return true;
        return node.querySelector && (node.querySelector('[data-556-aov-upsell]') || node.querySelector('[data-aov556-proof-module]'));
      });
    }

    function trackProofModule(module) {
      if (!module || module.dataset.aov556ProofSeen === 'true') return;

      module.dataset.aov556ProofSeen = 'true';
      track('aov556_buy_proof_viewed', getOfferMeasurementPayload(getTierByVariantId(getSelectedVariantId()), {
        proof_package: module.getAttribute('data-aov556-proof-package') || '',
        proof_bonus: module.getAttribute('data-aov556-proof-bonus') || '',
        proof_sellable_six: module.getAttribute('data-aov556-proof-sellable-six') || ''
      }));
    }

    function setupProofTracking() {
      document.querySelectorAll('[data-aov556-proof-module]').forEach(function(module) {
        if (module.dataset.aov556ProofBound === 'true') return;

        module.dataset.aov556ProofBound = 'true';

        if (typeof IntersectionObserver === 'undefined') {
          trackProofModule(module);
          return;
        }

        if (!proofObserver) {
          proofObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              if (!entry.isIntersecting || entry.intersectionRatio < 0.35) return;

              trackProofModule(entry.target);
              proofObserver.unobserve(entry.target);
            });
          }, { threshold: [0.35] });

          cleanupCallbacks.push(function() {
            proofObserver.disconnect();
            proofObserver = null;
          });
        }

        proofObserver.observe(module);
      });
    }

    function setupDomObserver() {
      if (!document.body || typeof MutationObserver === 'undefined') return;

      var observer = new MutationObserver(function(mutations) {
        if (mutations.some(mutationHasAovNode)) {
          setupStickyToggle();
          setupUpgradeButtons();
          setupHeroPackageLinks();
          setupAddToCartTracking();
          setupProofTracking();
          scheduleLadderSync(STATE_SYNC_DELAY);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });

      cleanupCallbacks.push(function() {
        observer.disconnect();
      });
    }

    function setupStickyToggle() {
      document.querySelectorAll('[data-aov556-sticky-toggle]').forEach(function(toggle) {
        if (toggle.dataset.aov556ToggleBound === 'true') return;

        var sticky = toggle.closest('.sticky-atc--aov556');
        if (!sticky) return;

        toggle.dataset.aov556ToggleBound = 'true';
        sticky.classList.remove('is-package-expanded');
        toggle.setAttribute('aria-expanded', 'false');

        var onToggleClick = function() {
          if (window.innerWidth >= 750) return;

          var isExpanded = sticky.classList.toggle('is-package-expanded');
          toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        };

        toggle.addEventListener('click', onToggleClick);
        cleanupCallbacks.push(function() {
          toggle.removeEventListener('click', onToggleClick);
          delete toggle.dataset.aov556ToggleBound;
        });
      });
    }

    function setupUpgradeButtons() {
      document.querySelectorAll('[data-aov556-upgrade-tier]').forEach(function(button) {
        if (button.dataset.aov556UpgradeBound === 'true') return;

        button.dataset.aov556UpgradeBound = 'true';

        var onUpgradeClick = function(event) {
          event.preventDefault();
          var targetTier = button.dataset.aov556UpgradeTier || '1000';
          track('aov556_pdp_button_clicked', getOfferMeasurementPayload(getTierByVariantId(getSelectedVariantId()), {
            button_action: 'upgrade_tier',
            button_text: getButtonText(button),
            button_location: getButtonLocation(button),
            current_tier: getTierByVariantId(getSelectedVariantId()),
            target_tier: targetTier
          }));
          selectTier(targetTier, { scroll: true });
          track('aov556_tier_selected', getOfferMeasurementPayload(targetTier, {
            selection_source: 'upgrade_button'
          }));
        };

        button.addEventListener('click', onUpgradeClick);
        cleanupCallbacks.push(function() {
          button.removeEventListener('click', onUpgradeClick);
          delete button.dataset.aov556UpgradeBound;
        });
      });
    }

    function setupHeroPackageLinks() {
      document.querySelectorAll('.aov556-offer-hero__package-link').forEach(function(link) {
        if (link.dataset.aov556HeroLinkBound === 'true') return;

        link.dataset.aov556HeroLinkBound = 'true';

        var onHeroLinkClick = function() {
          track('aov556_pdp_button_clicked', getOfferMeasurementPayload(getTierByVariantId(getSelectedVariantId()), {
            button_action: 'scroll_to_packages',
            button_text: getButtonText(link),
            button_location: 'hero',
            selected_tier: getTierByVariantId(getSelectedVariantId()),
            target: link.getAttribute('href') || ''
          }));
        };

        link.addEventListener('click', onHeroLinkClick);
        cleanupCallbacks.push(function() {
          link.removeEventListener('click', onHeroLinkClick);
          delete link.dataset.aov556HeroLinkBound;
        });
      });
    }

    function setupAddToCartTracking() {
      document.querySelectorAll('button.product-form__submit[name="add"], .sticky-atc__button[data-sticky-add]').forEach(function(button) {
        if (button.dataset.aov556AtcTrackingBound === 'true') return;

        button.dataset.aov556AtcTrackingBound = 'true';

        var onAddToCartClick = function() {
          if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

          var tierKey = getTierByVariantId(getSelectedVariantId());
          track('aov556_add_to_cart_clicked', getOfferMeasurementPayload(tierKey, {
            button_text: getButtonText(button),
            button_location: getButtonLocation(button)
          }));
        };

        button.addEventListener('click', onAddToCartClick);
        cleanupCallbacks.push(function() {
          button.removeEventListener('click', onAddToCartClick);
          delete button.dataset.aov556AtcTrackingBound;
        });
      });
    }

    function onAjaxProductAdded(event) {
      var tierKey = getTierByVariantId(getSelectedVariantId());
      var eventDetail = event && event.detail;

      track('aov556_add_to_cart_success', getOfferMeasurementPayload(tierKey, {
        event_detail_present: Boolean(eventDetail)
      }));

      syncGiftWithCart();
    }

    syncLadderFromSelectedVariant();

    if (!setupPubSubSubscriptions()) {
      pubSubRetryTimer = setInterval(function() {
        if (!setupPubSubSubscriptions()) return;

        clearInterval(pubSubRetryTimer);
        pubSubRetryTimer = null;
      }, 50);
    }

    addDocumentListener('ajaxProduct:added', onAjaxProductAdded);
    addDocumentListener('change', onDocumentChange);
    setupDomObserver();
    setupStickyToggle();
    setupUpgradeButtons();
    setupHeroPackageLinks();
    setupAddToCartTracking();
    setupProofTracking();
    setupCountdowns();
    syncGiftWithCart();
  }

  start();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  }
})();
